import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Utils} from '../../../../../../common/services/Utils';
import {ProfessionTypeService} from '../../../../../../common_services/profession-type.service';
import {DictionaryService} from '../../../../services/dictionary.service';
import {ModuleENUM} from '../../../../../../common/enums/module.enum';
import {ModuleExtendedEdit} from '../../../../../../common/enums/module-extended-edit.enum';
import {Principal} from '../../../../../../common/services/principal';

@Component({
  selector: 'app-admission-subject-modal',
  templateUrl: './subject-for-admission-modal.component.html',
  styleUrls: ['./subject-for-admission-modal.component.scss']
})
export class SubjectForAdmissionModalComponent implements OnInit {

  dicDto = null;
  subjectTypeList = [];
  yearList = [];
  hasWriteAccess = false;

  constructor(public _dialogRef: MatDialogRef<SubjectForAdmissionModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _utils: Utils,
              private _dialog: MatDialog,
              private _professionTypeService: ProfessionTypeService,
              private _principal: Principal,
              private _dictionaryService: DictionaryService) {
    this.dicDto = Object.assign({}, data);
    this.hasWriteAccess = this._principal.isAdmin() ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
  }

  ngOnInit() {
    for (let i = 2010; i <= 2030; i++) {
      this.yearList.push(i);
    }

    this._dictionaryService.getDicAdmissionSubjectTypeList().subscribe(list => {
        this.subjectTypeList = list;
      }
    );
  }

  onSubmit() {
    this._dictionaryService.saveDicSubjectForAdmission(this.dicDto).subscribe(
      (data) => {
        this._utils.notifySuccess('common.saved_successfully', null);
        this._dialogRef.close(true);
      },
      error => {
        if (error.status == 409) {
          this._utils.notifyError('Запись уже существует', [this.dicDto.nameRu]);
        } else {
          this._utils.notifyError('error_occurred', null);
        }
        console.log(error);
      }
    );
  }

  close(): void {
    this._dialogRef.close(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dictionary/subject-for-admission-list/subject-for-admission-modal/subject-for-admission-modal.component.ts